import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Typography, TextField, Checkbox, FormControlLabel,
  Button, Container, Paper, useMediaQuery, useTheme, IconButton
} from '@mui/material';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { AuthContext } from './../../AuthContext/AuthContext';
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import property_pincode_new from './../../../Images/property_pincode_new.png';
import axios from 'axios';
import { BASE_URL } from './../../Api/ApiUrls';
import constructiongetstarted from "./../../../Assets/constructiongetstarted.png";
import dashboardbackground from "./../../../Assets/dashboardbackground.png";
import dashboardbackground1 from "./../../../Assets/dashboardbackground1.png";
import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';

// Turn "+91 70130 67430" / "917013067430" / "7013067430" into "7013067430"
const normalizePhone = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length > 10 && digits.startsWith('91') ? digits.slice(-10) : digits;
};

function ConstructionConsultationForm() {
  const { userId, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();

  const [userData, setUserData] = useState({
    name: '',
    email: '',
    phone: '',
    whatsappOptIn: true,
  });

  // Phone validation error state
  const [phoneError, setPhoneError] = useState('');

  // Fetch the logged-in user by id and auto-fill name, email and phone
  useEffect(() => {
    if (!userId) return;

    let cancelled = false;

    axios.get(`${BASE_URL}/users/${userId}/`)
      .then((res) => {
        if (cancelled) return;
        const user = res.data;
        if (!user) return;

        const fullName = [user.first_name, user.last_name]
          .filter(Boolean)
          .join(' ')
          .trim();

        setUserData((prev) => ({
          ...prev,
          name: fullName,
          email: user.email || '',
          phone: normalizePhone(user.mobile_no),
        }));
      })
      .catch((err) => {
        console.error('Error fetching user data:', err);
      });

    return () => {
      cancelled = true;
    };
  }, [userId]);

  // Phone number validation function
  const validatePhoneNumber = (phone) => {
    // Remove all spaces and special characters except digits
    const cleaned = phone.replace(/[^\d]/g, '');

    // Valid Indian mobile number: 10 digits, starts with 6,7,8,9
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!cleaned) {
      return 'Phone number is required';
    }
    if (!phoneRegex.test(cleaned)) {
      return 'Enter a valid phone number';
    }
    return '';
  };

  // Handle phone input change with formatting
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow only digits, spaces, +, and -
    const cleaned = value.replace(/[^\d+\s-]/g, '');
    setUserData({ ...userData, phone: cleaned });

    // Validate on change
    const error = validatePhoneNumber(cleaned);
    setPhoneError(error);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate only phone number before submission
    const phoneError = validatePhoneNumber(userData.phone);
    setPhoneError(phoneError);

    // Check if there are any validation errors
    if (phoneError) {
      setAlertMessage('Please fix the phone number error before submitting.');
      setShowFailure(true);
      return;
    }

    if (!userId) {
      setAlertMessage('User not authenticated. Please login again.');
      setShowFailure(true);
      return;
    }

    axios.post(`${BASE_URL}/consultant-req/`, {
      user_id: userId,
      interested_on: "Construction"
    })
    .then((response) => {
      setAlertMessage('Consultation request submitted successfully.');
      setShowSuccess(true);
    })
    .catch((err) => {
      console.error('Submission error:', err);
      setAlertMessage(
        err.response?.data?.message || 'Failed to submit consultation request.'
      );
      setShowFailure(true);
    });
  };

  return (
    <>
      {/* Header */}
      <Box sx={{
        position: 'sticky', top: 0, zIndex: 1200, bgcolor: 'background.paper',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{ background: 'black' }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: 'white' }}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography variant="h7" sx={{ color: 'white', fontWeight: 'bold', flexGrow: 1, textAlign: 'left' }}>
            PROPERTY PINCODER
          </Typography>
          <Box sx={{ width: 88, height: 50 }}>
            <img src={property_pincode_new} alt="PROPERTY PINCODER Logo" style={{ maxWidth: '100%', maxHeight: '100%', boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.6)', objectFit: 'contain' }} />
          </Box>
        </Box>

        {/* Tabs */}
        <Box sx={{
          padding: isMobile ? 1 : 0.5,
          display: 'flex',
          justifyContent: 'space-between',
          boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
        }}>
          {/* Construction - Active */}
          <Box
            component={Link}
            to="/constructions"
            sx={{
              flex: 1,
              textAlign: 'center',
              py: 2,
              textDecoration: 'none',
              position: 'relative',
              background: `
                linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
                url(${constructiongetstarted})
              `,
              backgroundBlendMode: 'overlay',
              borderRight: '1px solid rgba(0,0,0,0.1)',
              borderTopLeftRadius: '30px',
              boxShadow: `
                inset 0 0 15px rgba(0,0,0,0.2),
                0 4px 10px rgba(0,0,0,0.15)
              `,
              transform: 'scale(1.02)',
              transition: 'all 0.3s ease',
              zIndex: 1,
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: `
                  inset 0 0 20px rgba(0,0,0,0.15),
                  0 5px 12px rgba(0,0,0,0.18)
                `,
                '&::after': {
                  width: '70%',
                  backgroundColor: '#333333',
                }
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '70%',
                height: '3px',
                backgroundColor: '#333333',
                borderRadius: '3px',
                transition: 'all 0.3s ease',
              }
            }}>
            <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
              fontWeight: 800,
              color: '#333333',
              textShadow: '0 1px 3px rgba(255,255,255,0.5)',
              fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
              transform: 'scale(1.05)',
              transition: 'transform 0.3s ease',
            }}>
              Constructions
            </Typography>
          </Box>

          {/* Interiors - Inactive */}
          <Box
            component={Link}
            to="/interiors"
            sx={{
              flex: 1,
              textAlign: 'center',
              py: 2,
              position: 'relative',
              background: `
                linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
                url(${dashboardbackground})
              `,
              backgroundBlendMode: 'overlay',
              textDecoration: 'none',
              borderBottomRightRadius: '30px',
              boxShadow: `
                inset 0 0 15px rgba(0,0,0,0.2),
                0 2px 5px rgba(0,0,0,0.1)
              `,
              transform: 'scale(0.98)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: `
                  linear-gradient(145deg, rgb(35, 35, 35), rgb(25, 25, 25)),
                  url(${dashboardbackground1})
                `,
                transform: 'scale(1)',
                boxShadow: `
                  inset 0 0 20px rgba(0,0,0,0.3),
                  0 3px 8px rgba(0,0,0,0.2)
                `,
                '&::after': {
                  width: '70%',
                  backgroundColor: 'rgba(255,255,255,0.9)',
                }
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '0%',
                height: '3px',
                backgroundColor: 'transparent',
                borderRadius: '3px',
                transition: 'all 0.3s ease',
              }
            }}
          >
            <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
              fontWeight: 700,
              color: 'rgba(255,255,255,0.9)',
              letterSpacing: '1px',
              textShadow: '0 1px 5px rgba(0,0,0,0.7)',
              fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
              transform: 'scale(1)',
              transition: 'transform 0.3s ease',
            }}>
              Interiors
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Form */}
      <Container maxWidth="sm" sx={{ mt: 4, mb: 12 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 } }}>
          <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ fontWeight: 600, textAlign: 'center', mb: 3 }}>
            Talk to an Interior Designer
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Name"
              margin="normal"
              size="small"
              value={userData.name}
              onChange={(e) => setUserData({ ...userData, name: e.target.value })}
              required
            />

            <TextField
              fullWidth
              label="Email ID"
              margin="normal"
              size="small"
              value={userData.email}
              onChange={(e) => setUserData({ ...userData, email: e.target.value })}
              type="email"
              required
            />

            <TextField
              fullWidth
              label="Phone Number"
              margin="normal"
              size="small"
              value={userData.phone}
              onChange={handlePhoneChange}
              type="tel"
              required
              error={!!phoneError}
              helperText={phoneError || "Enter a valid phone number"}
              placeholder="987654XXXX"
              onBlur={() => {
                const error = validatePhoneNumber(userData.phone);
                setPhoneError(error);
              }}
              inputProps={{
                maxLength: 15
              }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={userData.whatsappOptIn}
                  onChange={(e) => setUserData({ ...userData, whatsappOptIn: e.target.checked })}
                  color="primary"
                />
              }
              label="Check Updates on Whatsapp"
              sx={{ mb: 2 }}
            />

            <Box sx={{ textAlign: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: 'red',
                  color: '#fff',
                  borderRadius: '20px',
                  px: 4,
                  py: 1,
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: '#cc0000' },
                }}
              >
                GET FREE CONSULTATION
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>

      {showSuccess && (
        <SuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            navigate("/constructions");
          }}
        />
      )}

      {showFailure && (
        <FailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage("");
            navigate("/construction-get-started");
          }}
        />
      )}

      <FormsBottomNavbar />
    </>
  );
}

export default ConstructionConsultationForm;